import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface Invite {
  token: string;
  isUsed: boolean;
  expiresAt: string;
  createdBy: { id: number; email: string };
  usedBy: { id: number; email: string } | null;
  createdAt: string;
  isExpired: boolean;
}

export interface GenerateInviteResponse {
  token: string;
  url: string;
  expires_at: string;
}

export const inviteService = {
  generateInvite: async (): Promise<GenerateInviteResponse> => {
    try {
      const response = await apiService.post(`${API_BASE_URL}/invite/generate/`, {});
      return response;
    } catch (error) {
      console.error('Error generating invite:', error);
      throw error;
    }
  },

  listInvites: async (): Promise<Invite[]> => {
    try {
      const response = await apiService.get(`${API_BASE_URL}/invite/list/`);
      return response;
    } catch (error) {
      console.error('Error listing invites:', error);
      throw error;
    }
  },

  deleteInvite: async (token: string): Promise<void> => {
    try {
      await apiService.delete(`${API_BASE_URL}/invite/${token}/delete/`);
    } catch (error) {
      console.error(`Error deleting invite ${token}:`, error);
      throw error;
    }
  },
};
